import React from 'react';
import moment from 'moment';
import { onFormatLogStatus } from '../../../../utils/constants/logs-statuses';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';

const tableColumns = ['Timestamp', 'Session Id', 'Agent Tags', 'Task', 'End State', 'Duration']

interface IActivitiesTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onClickLogDetails: (id: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const ActivitiesTable = ({
    rows,
    paginationData,
    rowsLoading,
    onClickLogDetails,
    setPaginationState,
}: IActivitiesTable) => {

    const formatString = (str: string): string => {
        return str?.split('_')
            .map(word => word?.charAt(0).toUpperCase() + word?.slice(1))
            .join(' ');
    };

    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        const startedAt = moment(row?.startedAt);
                        const completedAt = moment(row?.completedAt);
                        const duration = moment.duration(completedAt.diff(startedAt));

                        const totalSeconds = (duration.asMilliseconds() / 1000).toFixed(3);
                        const formattedDuration = `${totalSeconds} s`;
                        const value = onFormatLogStatus(row?.status)?.name
                        const text = onFormatLogStatus(row?.status)?.text || 'text-black'
                        const item = <div className={`${text}`}>{value}</div>
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50 cursor-pointer hover:bg-gray-50' onClick={() => onClickLogDetails(row?._id || row?.id)}>
                                <td className='px-6 py-4'>{moment(row?.startedAt)?.format('DD/MM/YYYY, HH:mm')}</td>
                                <td className='px-6 py-4'>{row?.id || row?._id}</td>
                                <td className='px-6 py-4'>{formatString(row?.agent)}</td>
                                <td className='px-6 py-4'>{row?.task}</td>
                                <td className='px-6 py-4'>{item}</td>
                                <td className='px-6 py-4'>{formattedDuration}</td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default ActivitiesTable;